export const SliderArrow = ({ className, onClick, children, style, ...rest }: { className?: string; onClick?: () => void; children: React.ReactNode; style?: React.CSSProperties; [key: string]: any }) => {
  return (
    <button
      style={{
        zIndex: 10,
        backgroundColor: 'transparent',
        ...style,
      }}
      className={`absolute top-1/2 -translate-y-1/2 rounded-none p-3 ${className} cursor-pointer text-gray-100`}
      onClick={onClick}
      {...rest}
    >
      {children}
    </button>
  );
};